import { LegalPage, Clause, LegalFooterNote } from "../components/LegalPage";

export default function Terms() {
  return (
    <LegalPage overline="The small print" title="Terms of Service" updated="June 2026" testId="terms-page">
      <Clause heading="Using this site">
        <p>
          This is a personal library kept by Tirthak Saha, offered freely and as-is. Browsing it, signing in and
          keeping a reading list are all free. By using the site you accept the terms on this page.
        </p>
      </Clause>

      <Clause heading="Your account">
        <p>
          An account exists only to remember your reading list, notes and progress. You are responsible for the
          Google account you sign in with. Please don't attempt to access anyone else's account or the curator's
          dashboard, and don't try to disrupt the site for other readers.
        </p>
      </Clause>

      <Clause heading="Your notes">
        <p>
          Notes you write remain yours. They are stored privately for your own use and are not published anywhere on
          the site. Please keep them lawful — anything unlawful may be removed along with the account.
        </p>
      </Clause>

      <Clause heading="The catalogue">
        <p>
          Descriptions, curriculums and editorial notes are the work of the site owner. Book covers, artwork and
          quoted material belong to their respective rights holders and appear here for reference and commentary.
          Links to booksellers and other sites are provided for convenience; this site is not responsible for their
          content. If you hold rights to something shown here and would like it removed, get in touch and it will be.
        </p>
      </Clause>

      <Clause heading="No guarantees">
        <p>
          Entries, recommendations and curriculums are one reader's opinion, offered without warranty of accuracy or
          fitness for any purpose. The site may be unavailable, changed or discontinued at any time, and features may
          come and go. Nothing here is professional advice.
        </p>
      </Clause>

      <Clause heading="Ending things">
        <p>
          You can stop using the site whenever you like and ask for your account to be deleted. Accounts that abuse
          the site may be removed without notice.
        </p>
      </Clause>

      <Clause heading="Contact">
        <p>
          Anything to raise: <a href="mailto:hello@tirthaksaha.com" className="text-brass link-underline">hello@tirthaksaha.com</a>.
        </p>
      </Clause>

      <LegalFooterNote>These terms may be updated; the date at the top shows when they last were.</LegalFooterNote>
    </LegalPage>
  );
}
